import React from 'react';
import AppDropdown from '../../../components/AppDropdown';
import '../CRM.css';

const STATUS_OPTIONS = ['New', 'Contacted', 'Interested', 'Not Interested', 'Qualified', 'Requirement', 'Quotation', 'Negotiation', 'Won', 'Lost', 'Converted'].map((s) => ({ value: s, label: s }));
const PRIORITY_OPTIONS = ['High', 'Medium', 'Low'].map((s) => ({ value: s, label: s }));
const SALESPERSON_OPTIONS = ['Rahul Sharma', 'Priya Verma', 'Amit Kumar', 'Sneha Patel'].map((s) => ({ value: s, label: s }));
const SOURCE_OPTIONS = ['IndiaMART', 'Manual', 'Website', 'Referral', 'Other'].map((s) => ({ value: s, label: s }));

export const OpportunityCard = ({ opp, onOpen, onQuotation }) => (
  <div className="crm-kanban-card" draggable>
    <div className="crm-kanban-card-id">{opp.opportunityId}</div>
    <div className="crm-kanban-card-name">{opp.customerName}</div>
    <div className="crm-kanban-card-company">{opp.company}</div>
    <div className="crm-kanban-card-value">₹{Number(opp.expectedValue || 0).toLocaleString('en-IN')}</div>
    <div className="crm-kanban-card-meta">
      <span>{opp.salesperson || 'Unassigned'}</span>
      <span>{opp.probability || 0}% · {opp.expectedCloseDate || '—'}</span>
    </div>
    <div style={{ display: 'flex', gap: 6, marginTop: 9 }}>
      <button className="crm-btn crm-btn-sm crm-btn-outline" onClick={() => onOpen?.(opp)}>View</button>
      {onQuotation && (
        <button className="crm-btn crm-btn-sm crm-btn-primary" onClick={() => onQuotation?.(opp)}>Quotation</button>
      )}
    </div>
  </div>
);

export const LeadFilters = ({ filters, onChange, onClear, search, onSearchChange, children }) => {
  const set = (k) => (v) => onChange({ ...filters, [k]: v });
  return (
    <div className="crm-filters">
      <div className="crm-search-box">
        <span>🔍</span>
        <input value={search || ''} onChange={(e) => onSearchChange?.(e.target.value)}
          placeholder="Search customer, company, mobile, email, ID..." />
      </div>
      <div className="crm-status-filter" role="group" aria-label="Filter by status">
        <AppDropdown value={filters.status || ''} options={STATUS_OPTIONS} onChange={set('status')}
          placeholder="All Status" menuWidth={200} menuClassName="crm-dropdown-window" />
      </div>
      <div className="crm-status-filter" role="group" aria-label="Filter by priority">
        <AppDropdown value={filters.priority || ''} options={PRIORITY_OPTIONS} onChange={set('priority')}
          placeholder="All Priority" menuWidth={180} menuClassName="crm-dropdown-window" />
      </div>
      <div className="crm-status-filter" role="group" aria-label="Filter by salesperson">
        <AppDropdown value={filters.salesperson || ''} options={SALESPERSON_OPTIONS} onChange={set('salesperson')}
          placeholder="All Salespersons" menuWidth={200} menuClassName="crm-dropdown-window" />
      </div>
      <div className="crm-status-filter" role="group" aria-label="Filter by source">
        <AppDropdown value={filters.source || ''} options={SOURCE_OPTIONS} onChange={set('source')}
          placeholder="All Sources" menuWidth={200} menuClassName="crm-dropdown-window" />
      </div>
      <input type="date" value={filters.fromDate || ''} onChange={(e) => onChange({ ...filters, fromDate: e.target.value })} title="From date" />
      <input type="date" value={filters.toDate || ''} onChange={(e) => onChange({ ...filters, toDate: e.target.value })} title="To date" />
      <button className="crm-btn crm-btn-sm crm-btn-ghost" onClick={onClear}>Clear</button>
      {children}
    </div>
  );
};

export default OpportunityCard;
